export default "__VITE_ASSET__CzzBFlvm__"